
  import { Component, Vue, Watch } from 'vue-property-decorator'

  @Component({
    components: {
    }
  })

  export default class User extends Vue  {
    dialog = false
    addDialog = false
    menu = false
    dialogDelete = false
    loading = false

    editedIndex = -1
    editedItem: object = {
      id: -1,
      name: '',
      email: '',
      expiration: '',
      bridge_expiration: '',
      username: ''
    }
    defaultItem: object = {
      id: -1,
      name: '',
      email: '',
      expiration: '',
      bridge_expiration: '',
      username: ''
    }

    errors = []
    messages = ''
    search = ''
    headers: Array<object> = [
      { text: 'Email', value: 'email' },
      { text: 'Name', value: 'name' },
      { text: 'expiration', value: 'bridge_expiration' },
      { text: 'Bridge Access', value: 'access' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]

    rules: any =  {
      required: value => !!value || 'Required.',
      min: v => v.length >= 8 || 'Min 8 characters',
      emailMatch: () => (`The email and password you entered don't match`),
    }

    items: Array<object> = []
    accessInfo: any = {
      name: '',
      email: '',
      username: '',
      password: '',
      confirmPassword: '',

      expiration: '',
      bridge_expiration: '',
      user_id: '',
      roles: 'View',
      application: 'bridge-app'
    }

    defaultAccessInfo: any = {
      name: '',
      email: '',
      username: '',
      password: '',
      confirmPassword: '',

      expiration: '',
      bridge_expiration: '',
      user_id: '',
      roles: 'View',
      application: 'bridge-app'
    }

    roles = [
      { text: 'Admin', value: 3 },
      { text: 'Edit', value: 4 },
      { text: 'View', value: 5 }
    ]


    //Computed
    get getUsers(): Array<string|number|boolean> {
      return this.$store.getters['auth/getUsers']
    }

    get passwordConfirmationRule(): any {
      return (this.accessInfo.password === this.accessInfo.confirmPassword) || "The email and password you entered don't match"
    }

    //LifeCycle
    mounted () {
      this.initialize()
    }

    //Methods
    public initialize(): void {
      //payload bridge
      this.$store.dispatch('auth/getUsers', {'type': 'bridge-app'})
    }
    public close(): void {
      this.dialog = false
    }

    public closeAddForm(): void {
      this.addDialog = false
      
    }

    public save(): void {
      console.log('Hello')
    }
    public closeDelete(): void {
      this.dialogDelete = false
    }
    public deleteItemConfirm(): void {
      console.log('Hello')
    }

    public addItem(): void {
      this.addDialog = true
    }

    public addNewUser(): void {
      this.loading = true
      if(this.editedIndex > -1) {
        // @ts-ignore: Temporary
        this.axios.post(process.env.VUE_APP_TRAFFIC_API + 'api/updateBridgeUser', this.accessInfo)
          .then( response =>  {
            this.$store.dispatch('auth/getUsers', {'type': 'bridge-app'})
            this.loading = false
            this.accessInfo = this.defaultAccessInfo
            this.messages = response.data.name + ' was added.'
            this.addDialog = false
          })
          .catch( error => {
            this.errors = error.response.data.errors
            this.loading = false
          })
      }
      else {
        // @ts-ignore: Temporary
        this.axios.post(process.env.VUE_APP_TRAFFIC_API + 'api/addNewBridgeUser', this.accessInfo)
          .then( response =>  {
            this.$store.dispatch('auth/getUsers', {'type': 'bridge-app'})
            this.loading = false
            this.accessInfo = this.defaultAccessInfo
            this.messages = response.data.name + ' was added.'
            this.addDialog = false
          })
          .catch( error => {
            this.errors = error.response.data.errors
            this.loading = false
          })

      }
    }

    public editItem(item: any): void {
      this.editedIndex = this.getUsers.indexOf(item)
      this.accessInfo = Object.assign({}, item)
      //Fix Access Info
      if(this.accessInfo.roles.length > 1)
        this.accessInfo.roles = this.accessInfo.roles.find(x => x.id === 3).id
      else if (this.accessInfo.roles.length  == 1) {
        this.accessInfo.roles = this.accessInfo.roles[0].id
      }
      else {
        this.accessInfo.roles = []
      }
      this.addDialog = true
    }
    public deleteItem(item: object): void {
      //this.deletingBridge = true
      //const index = this.bridges.indexOf(item)
      //confirm('Are you sure you want to delete this item?') && this.bridges.splice(index, 1)
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridge', item)
      //Dispatch
    }

    public revokeAccess(item): void {
      const r = confirm("Are you sure you want to remove access for this user: " + item.name + "?");
      if (r) {
        this.loading = true
        // @ts-ignore: Temporary
        this.axios.post(process.env.VUE_APP_TRAFFIC_API + 'api/toggleBridgeAccess', { id: item.user_id, application: 'bridge-app' })
          .then( response =>  {
            this.$store.dispatch('auth/getUsers', {'type': 'bridge-app'})
            this.loading = false
          })
          .catch( error => {
            this.loading = false
          })
      }
    }

    public giveAccessForm(item): void {
      this.dialog = true
      this.accessInfo.user_id = item.user_id
      this.accessInfo.expiration = ''
    }

    public giveAccess(): void {
      this.loading = true
      // @ts-ignore: Temporary
      this.axios.post(process.env.VUE_APP_TRAFFIC_API + 'api/toggleBridgeAccess', { 
              id: this.accessInfo.user_id, 
              application: this.accessInfo.application,
              expiration: this.accessInfo.expiration,
              roles: this.accessInfo.roles
      })
      .then( response =>  {
        this.$store.dispatch('auth/getUsers', {'type': 'bridge-app'})
        this.dialog = false
        this.loading = false
      })
      .catch( error => {
        this.loading = false
      })
    }
  }
